'use strict'

import ScrollMagic from 'scrollmagic';
import {TweenLite, TweenMax, TimelineMax} from 'gsap';
import CSSRulePlugin from "gsap/CSSRulePlugin";
import animationGsap from '../lib/animation.gsap';
import debug from '../lib/debug.addIndicators';


let self

export default self = {
  homeCover: document.querySelector('#home-cover'),

  init : () => {
    const controller = new ScrollMagic.Controller();

    /*---------------------------------------*/
    /*          Buyer and Seller             */
    /*---------------------------------------*/

    const buyer_btn = document.querySelectorAll('#home-buyers-sellers .global-read-more');
    const buyerAnimation = new TimelineMax()
      .set(buyer_btn, {className: '+=expand'})
      .staggerFrom('#home-buyers-sellers .fadein', 0.6, {x: -50, autoAlpha: 0, ease:Power0.easeNone}, 0.3)
      .set(buyer_btn, {className: '-=expand'});

    const scene = new ScrollMagic.Scene({
              triggerElement: '#home-buyers-sellers',
              triggerHook: 0.8,
              reverse: true
          })
          .setTween(buyerAnimation)
          // .addIndicators({name: "FadeIn"})
          .addTo(controller);


    /*---------------------------------------*/
    /*          Featured Listings            */
    /*---------------------------------------*/
    const listing = document.querySelectorAll('#home-featured-listings .listing');
    const text = document.querySelectorAll('#home-featured-listings .listing__info');
    const btn = document.querySelectorAll('#home-featured-listings .global-read-more');

    const wipeAnimation = (listing, text, btn) => (
      new TimelineMax()
        .set(btn, {className: '+=expand'})
        .set(text, {xPercent: -50, autoAlpha: 0, transformOrigin: 'left center'})
        .from(listing, 0.6, {autoAlpha: 0, x: '-40px', ease: Power1.easeOut})
        .to(text, 0.6, {xPercent: 0, autoAlpha: 1, ease: Power1.easeOut}, '-=0.3')
        .set(btn, {className: '-=expand'})
    );

    [...listing].forEach( (item, i) => {
      let args = {
        triggerElement: '#home-featured-listings',
        triggerHook: 0.5
      }

      if (i !== 0) args.triggerElement = listing[i-1]

      const sceneWipe1 = new ScrollMagic.Scene(args)
        .setTween(wipeAnimation(listing[i], text[i], btn[i]))
        .addTo(controller)

    })



    /*---------------------------------------*/
    /*             Home Book                 */
    /*---------------------------------------*/

    const book_btn = document.querySelector('#home-book-cta .global-read-more');
    const bookAnimation = new TimelineMax()
      .set(book_btn, {className: '+=expand'})
      .from('.book-img', 0.6, {x: -50, autoAlpha: 0, ease: Power1.easeOut})
      .from('#home-book-cta .col-onethird', 0.6, {x: -50, autoAlpha: 0, ease: Power1.easeOut})
      .set(book_btn, {className: '-=expand'});

    const sceneBook = new ScrollMagic.Scene({
              triggerElement: '#home-book-cta',
              triggerHook: 0.6,
          })
          .setTween(bookAnimation)
          // .addIndicators({name: "book"})
          .addTo(controller);


    /*---------------------------------------*/
    /*             Home Grey                 */
    /*---------------------------------------*/
    const greyCol = document.querySelectorAll('#home-grey-cta .inner-wrap > div');
    const grey_btn = document.querySelectorAll('#home-grey-cta .global-read-more');
    const greyAnimation = new TimelineMax()
      .set(grey_btn, {className: '+=expand'})
      .staggerFrom(greyCol, 0.6, {x: 50, autoAlpha: 0, ease: Power1.easeOut}, 0.3)
      .set(grey_btn, {className: '-=expand'});


    const sceneGrey = new ScrollMagic.Scene({
              triggerElement: '#home-grey-cta',
              triggerHook: 0.3,
          })
          .setTween(greyAnimation)
          // .addIndicators({name: "grey"})
          .addTo(controller);



  },



}
